import React,{useState} from "react";
import { useDispatch } from "react-redux";
import { userResetPassword } from "../store/actions/User";

import ImgLogo from  "./img/koooviblank.gif";
import Navber from "../Navbar/UserMenu";
import Loading from "./Loading/Loading";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUp.css'
import {  Link  } from "react-router-dom";
const ResetPassword = ()=>{

 const dispatch = useDispatch();
  

  const history = useHistory();
 
 const [loader , setLoader] =useState({status:false});
 const [ResetPassword, setResetPassword] = useState({user_email:''
 
});




/* Handle Signup Function */
const handleResetPassword=(e)=>{
  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(userResetPassword(ResetPassword));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
      
      history.push('/resetPassOTP');

    }else{


    }
    ;
   

/* resetting Login input Fields */

setResetPassword({user_email:'',user_pass:""

})

setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
    
/* resetting Login input Fields */
setResetPassword({user_email:''

})
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleResetPassword} >
  <div  className="ikcraft_login-signup-backgropj"><div  className="ikcraft_login-signup-card"><div  className="blank"> </div>
  <div  className="ikcraft_login-signup-card-outerj"><div  className="ikcraft_login-signup-inner">
  <div  className="ikcraft_blankRight ikcraft_login-signup-right-signup">
      <div></div>
      <div><Link  style={{ float:'left'
    ,padding:'10px 25px',
  textDecoration: 'none',
  position: 'relative',
  top: '2px',
  fontSize: '65px',textAlign:'center',
  border: '0px',
  fontWeight: 'bold',
  background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}}  to="">
               
                <span >ClassMock</span>
                </Link> </div> <div>  <div className="ikcraft_Login-bottom"><div  style={{padding:'15px',fontSize:'12px'}}> New To ClassMock?  </div><Link to="./signup">
      <div className="ikcraft_course-btn-green">
     Sign Up Here
    </div> </Link></div></div>
    </div>  <div  className="ikcraft_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Reset Password </h1>
      
 <div  className="ikcraft_login-input-card">
 <input className="ikcraft_input-textbox" required placeholder="Email" type="text"
  name="user_email" value={ResetPassword.user_email} 
  onChange={(e)=>setResetPassword({...ResetPassword, user_email : e.target.value})} />
   </div>
	  
   
   
    
   
     
   
	
	<div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Send Reset OTP To Email </button>
      
  </div>
<div style={{padding:'5px',fontSize:'18px',color:'#99cc99',textAlign:'center'}} > OR </div>
<Link to="./loginWithOTP">
  <div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Login With OTP </button>
      
  </div></Link>
  
  <div> 
  <div className="ikcraft_Login-bottom"><div  style={{padding:'15px',fontSize:'12px'}}> New To ClassMock?  </div><Link to="./signup">
      <div className="ikcraft_course-btn-green">
     Sign Up Here
    </div> </Link></div>
    <div className="ikcraft_Login-bottom"><div  style={{padding:'15px',fontSize:'12px'}}> Have Password?  </div>
    <Link to="./login">
      <div className="ikcraft_course-btn-green">
     Login  Here
    </div> </Link></div>
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div></div>
   </form>
</>}
    </>

}
export default ResetPassword;